
import {Component, Vue} from "vue-property-decorator";
import {currentUserModule} from "@/store";
import DocumentTable from "@/components/document/DocumentTable.vue";

@Component({
  components: {
    DocumentTable,
  }
})
export default class DocumentsView extends Vue {
  async mounted() {
    await currentUserModule.loadIfEmpty();
  }
}
